import React, { FunctionComponent } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { amber } from '@mui/material/colors';

const font = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;

const theme = createTheme({
  palette: {
    primary: {
      main: '#06f',
      light: '#eef6f8',
    },
    secondary: amber,
  },
  typography: {
    fontFamily: font,
    fontSize: 15,
  },
});

const ThemeWrap: FunctionComponent = ({ children }) => (
  <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
);

export default ThemeWrap;
